<template>
  <i
    class="nav-svg-icon icon-expand pointer w-22"
    @click="$emit('showExpandedDialog')" />
</template>
<script>
export default {
  name: 'ProductCellExpandedView',
};
</script>

<style scoped lang="scss">
.nav-svg-icon.w-22 {
  width: 22px;
}
</style>